module.exports = __webpack_public_path__ + "static/media/lu.23370f93.svg";